import { render, staticRenderFns } from "./layout3.vue?vue&type=template&id=8cd1f26a&scoped=true&"
import script from "./layout3.vue?vue&type=script&lang=js&"
export * from "./layout3.vue?vue&type=script&lang=js&"
import style0 from "./layout3.vue?vue&type=style&index=0&id=8cd1f26a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cd1f26a",
  null
  
)

export default component.exports